
<template>
    <div ref="listWrap">
        <wrapper-list
                @edit="paasEidtPage"
                @delete="paasDeleteTableData"
                @detail="paasDetailPage"
                @calculate="paasCalculate"
                ref="wrapperList" >
            <Form class="list-query-wrap" slot="query" :model="queryParam" :label-width="defaultLabelWidth" ref="queryForm">
                <row class="list-query-row">
                    <FormItem label="订单号" class="list-query-item">
                        <Input  v-model="queryParam.query_LIKE_orderCode" placeholder=""
                                @on-change="queryTableDatas('param')" clearable />
                    </FormItem>
                </row>
            </Form>
            <Table slot="table" stripe border :height="tableHeight"
                   :data="tableData"
                   :columns="tableColumns"
                   @on-selection-change="selectTableDataChange"
                   @on-sort-change="sortTableData"
                   :no-data-text="noDataText">
            </Table>
            <Page slot="page"  :total="totalRecords"
                  show-total show-sizer
                  @on-change="changePage"
                  @on-page-size-change="changePageSize">
            </Page>
        </wrapper-list>
    <Modal v-model="addExpressModal" class="paas-select-page"  title='填写快递信息' @on-ok="saveExpress()" :mask-closable=false >
      <Express ref="addExpress" :order = "order"  v-if= "isShow"/>
    </Modal>

    

    <Modal v-model="expressDetail" class="paas-select-page"  title="查看快递信息"  :mask-closable=false  cancel-text="返回">
      <Detail ref="express" :paasData ="paasData"/>
    </Modal>
    </div>
</template>
<script>
    import wrapperList from "@components/paas/wrapper-list";
    import metaList from "@assets/js/list/meta-list.js";
    import CellBar from '@components/paas/cell-bar' //列表内操作
    import EnumShow from "@components/paas/enum-show";  //如果有枚举，需要引入
    import Express from "./express.vue"
    import Detail from "./detail.vue"
    import {saveSendRecord,getOrderSend,getNeedSendProduct} from '@api/order';
    export default {
        name: "list",
        mixins: [ metaList ],
        components: { wrapperList,CellBar, EnumShow,Express,Detail},
        data() {
            return {
                serviceUrl:"/eb/order",  //每个页面访问后台服务器的路径
                currentIdFiledName: 'id',
                queryParam:{
                    query_LIKE_orderCode:"",
                },
                order:{},
                paasData:[],
                isShow:false,
                index:0,
                defaultLabelWidth:200,
                addExpressModal:false,
                expressDetail:false,
                defaultGetTabeleFun:"/getSendOrderList",
                tableColumns:[
                    {
                        type: 'expand',
                        width: 50,
                        render: (h, params) => {
                            return h(OrderExpand, {
                                props: {
                                    rowData: params.row
                                }
                            })
                        }
                    },
                    {
                        title: '订单号',
                        key: 'orderCode',
                        width:150,
                    },
                    {
                        title: '买家信息',
                        key: 'buyer',
                        "width": 160,
                        render:(h,params)=>{
                            var buyer = params.row.buyer?params.row.buyer:"无";
                            return h('div',[
                                h('p', {},"买家昵称："+buyer),
                                h('p', {},"收货人："+params.row.realName)
                            ])
                        }
                    },
                    {
                        title: '购买商品',
                        key: 'orderProductList',
                        render:(h,params)=>{
                            let  showData = [];
                            let  products = params.row.orderProductList;
                            for(let i = 0;i< products.length;i++){
                                let oneData = products[i].name +" - " + products[i].productAttr+": "+ products[i].purchaseNum
                                showData.push(oneData+'\n');
                            }
                            return h('div',showData);
                        }
                    },

                    {
                        title: '收货人手机',
                        key: 'userPhone',
                        width:125,
                    },
                    {
                        title: '详细地址',
                        key: 'userAddress',
                        width:200
                    },
                    {
                        title: '数目',
                        key: 'totalNum',
                        width:100,
                    },
                    {
                        title: '支付时间',
                        key: 'payTime',
                    },
                    {
                        title: '操作',
                        fixed: 'right',
                        render: (h, params) => {
                            let that = this;
                            let statusOperate = [];
                            let auditBtn = h('Button', {
                                props: {
                                    type: 'error',
                                    size: 'small'
                                },
                                on: {
                                    click: () => {
                                        //重新获取要发货的产品列表
                                        that.getNeedSendProduct(params.row);
                                    }
                                }
                            }, '发货');

                            let editBtn = h('Button', {
                                props: {
                                    type: 'warning',
                                    size: 'small'
                                },
                                style:{
                                    marginLeft:'10px'
                                },
                                on: {
                                    click: () => {
                                        this.$router.push({'path': "/eb/order/send/edit?id="+params.row.id,
                                    });
                                    }
                                }
                            }, '修改物流');
                           
                            let detailBtn = h('Button', {
                                props: {
                                    type: 'info',
                                    size: 'small'
                                },
                                on: {
                                    click: () => {
                                        that.getOrderSend(params.row.id);
                                    }
                                }
                            }, '查看物流');
                            //待发货
                           
                            if(params.row.sendType == 0){
                                statusOperate.push(auditBtn);
                            }
                            //已发货
                            else if(params.row.sendType == 1){
                                statusOperate.push(detailBtn);
                                statusOperate.push(editBtn);
                            }else{
                                statusOperate = "该订单已取消";
                            }
                            return h('div',statusOperate);
                        }
                    }
                ],
            }
        },
        mounted(){
        },
        methods:{
          async  saveExpress(){
                let send = this.$refs.addExpress.paasFormData;
                send.orderCode = this.order.orderCode;
                send.orderId = this.order.id;
                let  {code,data} = await saveSendRecord(send);
                if(code===200){
                    this.queryTableDatas();
                    this.isShow = true;
                    this.$nextTick(()=>{
                      this.isShow = false;
                    })
                }

            },
            async getOrderSend(id){
                let  {code,data} = await getOrderSend(id);
                if(code===200){
                    this.paasData = data;
                    this.expressDetail = true;
                }
            },
            
            async getOrderInfo(id){
                let  {code,data} = await getOrderSend(id);
                if(code===200){
                    this.paasData = data;
                    this.expressDetail = true;
                }
            },

            async getNeedSendProduct(row,type){
                let  {code,data} = await getNeedSendProduct(row.id);
                if(code===200){
                    debugger
                    row.orderProductList = data;
                    this.order = row;
                    this.addExpressModal = true;
                    this.isShow = true;
                }
            }
        }
    }
</script>
